import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';

import './../fields.css';

const RadioField = ({ input, options, placeholder, intl, hideErrors, selectedValue, meta: { touched, error, warning } }) => (
    <div className="radio-field form-group no-select">
        <div
            className="label-container"
            dangerouslySetInnerHTML={{ __html: typeof placeholder === 'string' ? placeholder : intl.formatHTMLMessage(placeholder, placeholder.values) }}
        />
        {options.map((option, i) => {
            return (
                <label key={i}>
                    {selectedValue === undefined ? (
                        <input type="radio" {...input} value={option.value} />
                    ) : (
                        <input type="radio" {...input} value={option.value} checked={selectedValue.toString() === option.value.toString()} />
                    )}
                    {option.label}
                </label>
            );
        })}
        {hideErrors === undefined && <span className="validation-message">{touched && (error || warning)}</span>}
    </div>
);

RadioField.defaultProps = {
    placeholder: '',
    meta: {},
    input: {},
    options: []
};

RadioField.propTypes = {
    placeholder: PropTypes.any,
    meta: PropTypes.object,
    input: PropTypes.object,
    options: PropTypes.array.isRequired
};

export default injectIntl(RadioField);



// WEBPACK FOOTER //
// ./src/components/fields/radio/index.jsx